import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CustomerSentimentFiltersDialog from "./CustomerSentimentFiltersDialog";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import FilterChipDisplay from "../../FilterChipDisplay";

interface ISentimentFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function CustomerSentimentFilters({ callTableViewModel, setCallTableViewModel }: ISentimentFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                'Customer'
            }
            {
                (callTableViewModel.filters.customerSentimentFilters.isStartingSentimentEnabled ||
                    callTableViewModel.filters.customerSentimentFilters.isMiddleSentimentEnabled ||
                    callTableViewModel.filters.customerSentimentFilters.isFinalSentimentEnabled) ?
                    ` - Sentiment Active` : ''
            }
            {
                (callTableViewModel.filters.customerSentimentFilters.isStartingMoodEnabled ||
                    callTableViewModel.filters.customerSentimentFilters.isMiddleMoodEnabled ||
                    callTableViewModel.filters.customerSentimentFilters.isFinalMoodEnabled) ?
                    ` - Mood Active` : ''
            }
            {
                (callTableViewModel.filters.customerSentimentFilters.isStartingFrictionEnabled ||
                    callTableViewModel.filters.customerSentimentFilters.isMiddleFrictionEnabled ||
                    callTableViewModel.filters.customerSentimentFilters.isFinalFrictionEnabled) ?
                    ` - Friction Active` : ''
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <CustomerSentimentFiltersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel} />
        </>
    )
}